import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { LOGO_URL } from "@/lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${BASE}/api/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status !== "paid" && tries < 15) {
          setTimeout(() => setTries((t) => t + 1), 2000);
        }
      } catch {
        if (!cancelled && tries < 15) setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, tries]);

  const paid = status.payment_status === "paid";

  return (
    <div data-testid="payment-success-root" className="min-h-screen bg-stone-50 flex items-center justify-center p-8">
      <div className="ns-card max-w-lg w-full p-10 text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <img src={LOGO_URL} alt="" className="w-10 h-10 rounded-lg" />
          <div className="ns-label">Newport Stays</div>
        </div>
        {paid ? (
          <>
            <CheckCircle2 className="w-14 h-14 text-teal-600 mx-auto" />
            <h1 className="font-serif text-4xl mt-6">You're booked in.</h1>
            <p className="mt-3 text-slate-500">
              Payment received. A confirmation email is on its way — we'll be in touch a few days before arrival with
              your door code and Wi-Fi.
            </p>
          </>
        ) : (
          <>
            <Loader2 className="w-14 h-14 text-teal-600 mx-auto animate-spin" />
            <h1 className="font-serif text-3xl mt-6">Confirming your payment…</h1>
            <p className="mt-3 text-slate-500 text-sm">
              This usually takes a few seconds. Please don't close this page.
            </p>
          </>
        )}
        <div className="mt-8 text-[11px] tracking-widest uppercase text-slate-400">
          <Link to="/">Back to Newport Stays</Link>
        </div>
      </div>
    </div>
  );
}
